import { DEMO } from '@pz/server/demo-personas';

/** Current demo persona (kept outside lib/demo.ts so that the UI does not import the demo runtime). */
let current: string = DEMO.keller;
const listeners = new Set<() => void>();

try {
  const saved = localStorage.getItem('pz-demo-person');
  if (saved) current = saved;
} catch {
  /* storage not available */
}

export function demoPersonId() {
  return current;
}

export function setDemoPerson(id: string) {
  current = id;
  try {
    localStorage.setItem('pz-demo-person', id);
  } catch {
    /* storage not available */
  }
  listeners.forEach((l) => l());
}

export function onDemoPersonChange(fn: () => void) {
  listeners.add(fn);
  return () => {
    listeners.delete(fn);
  };
}

/**
 * Additional confirmation for Abrechnung and Kunden in the demo (request 31 of round 4): the demo has no passwords, the
 * confirmation word is "demo". Kept per persona in memory, like the session row of the real server, on the clock of the
 * demo (the server logic compares it with that clock).
 */
const stepUps = new Map<string, string>();
let demoClock: () => Date = () => new Date();

export function setDemoClock(fn: () => Date) {
  demoClock = fn;
}

export function demoStepUp(password: string): boolean {
  if (password.trim().toLowerCase() !== 'demo') return false;
  stepUps.set(current, demoClock().toISOString());
  return true;
}

export function demoStepUpAt(): string | null {
  return stepUps.get(current) ?? null;
}
